import { render } from "./_CoachCatalogueSearch.vue?vue&type=template&id=43e580ad"
import script from "./_CoachCatalogueSearch.vue?vue&type=script&lang=js"
export * from "./_CoachCatalogueSearch.vue?vue&type=script&lang=js"

import "./_CoachCatalogueSearch.vue?vue&type=style&index=0&id=43e580ad&lang=scss"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__